import { IExternalImageRegistry } from "../../../domain/externalImage";
import { ExternalImageRepository } from ".";

export class ExternalImageRegistry implements IExternalImageRegistry {
  constructor(getToken: () => string) {
    this._repository = new ExternalImageRepository(getToken);
  }

  private readonly _repository: ExternalImageRepository;
  
  getExternalImageRepository(): ExternalImageRepository {
    return this._repository;
  }
}
